import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 36,
      height: 20,
      padding: 0,
    },
    switchBase: {
      padding: 1,
      color: '#849097',
      '&$checked': {
        transform: 'translateX(16px)',
        color: '#FFFFFF',
        '& + $track': {
          backgroundColor: '#0179D2',
          opacity: 1,
          border: `1px solid transparent`,
        },
      },
    },
    thumb: {
      width: 18,
      height: 18,
    },
    track: {
      height: 'calc(100% - 2px)',
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: '#F2F4F6',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });

export default IOSSwitch;